export default {
  FOOTER: `respaldado por`,
};
